import { TYPES } from "../actions";

const initialState = {
  sims: [],
  totalCount: 0,
  currentSim: null,
  loading: false
};

export const tkt1SimReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_SIMS_SUCCESS:
      return { 
        ...state, 
        sims: action.payload.data.data, 
        totalCount: action.payload.data.pagination?.total_count > -1 ? action.payload.data.pagination.total_count : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_SIMS_FAIL:
      return { 
        ...state, 
        sims: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_SIM_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentSim: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_SIM_BY_ID_FAIL:
      return { 
        ...state, 
        currentSim: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_SIM_SUCCESS:
      return { 
        ...state, 
        sims: [action.payload.data, ...state.sims],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_SIM_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_SIM_SUCCESS:
      return { 
        ...state, 
        sims: state.sims.map(sim => 
          sim._id === action.payload.data._id ? action.payload.data : sim
        ),
        currentSim: state.currentSim && state.currentSim._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentSim,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_SIM_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_SIM_SUCCESS:
      return { 
        ...state, 
        sims: state.sims.filter(sim => sim._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentSim: state.currentSim && state.currentSim._id === action.payload.id 
          ? null 
          : state.currentSim,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_SIM_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};